import { render, staticRenderFns } from "./AcademicRenewalDetailPage.vue?vue&type=template&id=026d35f7"
import script from "./AcademicRenewalDetailPage.vue?vue&type=script&lang=js"
export * from "./AcademicRenewalDetailPage.vue?vue&type=script&lang=js"
import style0 from "./AcademicRenewalDetailPage.vue?vue&type=style&index=0&id=026d35f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports